import { cn } from "cn";

type Props = {
  title?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
};
export function GeneralHeader({ title, description, className }: Props) {
  return (
    <div className={cn("space-y-1 text-left", className)}>
      {title && (
        <h1 className="text-3xl font-semibold whitespace-pre-line">{title}</h1>
      )}
      {description && (
        <div className="text-base leading-normal font-normal text-text-dark-high">
          {description}
        </div>
      )}
    </div>
  );
}
